import React from 'react';
import { Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import {
    Activity,
    AlertOctagon,
    AlertTriangle,
    CheckCircle,
    Info,
    Moon,
    Star,
    Sun,
    X,
} from 'react-feather';
import { Button, Card, Col, Container, Row } from 'react-bootstrap';

export default function Alerts() {
    const topRight = () => {
        toast.success('بالا راست', {
            position: 'top-right',
        });
    };

    const top = () => {
        toast.error('بالا وسط', {
            position: 'top-center',
        });
    };

    const topLeft = () => {
        toast.info('بالا چپ', {
            position: 'top-left',
        });
    };

    const bottomRight = () => {
        toast.warn('پایین راست', {
            position: 'bottom-right',
        });
    };

    const bottom = () => {
        toast('پایین وسط', {
            position: 'bottom-center',
        });
    };

    const bottomLeft = () => {
        toast.dark('پایین چپ', {
            position: 'bottom-left',
        });
    };

    return (
        <>
            <Container fluid>
                <Col>
                    <nav aria-label='breadcrumb'>
                        <h2 className='mb-3'>اخطار و اطلاعیه</h2>

                        <ol className='breadcrumb'>
                            <li className='breadcrumb-item'>
                                <Link to='/'>کامپوننت ها</Link>
                            </li>

                            <li className='breadcrumb-item'>
                                <Link to='/alert'>اخطار و اطلاعیه</Link>
                            </li>

                            <li
                                className='breadcrumb-item active'
                                aria-current='page'
                            >
                                شما اینجایی
                            </li>
                        </ol>
                    </nav>
                </Col>

                <div className='space-20' />

                <Row>
                    <Col className='mb-4'>
                        <Card>
                            <Card.Title className='bg-transparent p-3'>
                                انواع رنگ ها و آیکون های اخطار
                            </Card.Title>
                            <Card.Body>
                                <div
                                    className='alert alert-primary d-flex align-items-center alert-dismissible fade show'
                                    role='alert'
                                >
                                    <Star className='mr-3' />
                                    این یک اخطار به همراه آیکون و به رنگ اصلی
                                    است.
                                    <div
                                        className='alert-close'
                                        data-bs-dismiss='alert'
                                        aria-label='Close'
                                    >
                                        <X />
                                    </div>
                                </div>

                                <div
                                    className='alert alert-secondary d-flex align-items-center alert-dismissible fade show'
                                    role='alert'
                                >
                                    <Activity className='mr-3' />
                                    این یک اخطار به همراه آیکون و به رنگ ثانوی
                                    است.
                                    <div
                                        className='alert-close'
                                        data-bs-dismiss='alert'
                                        aria-label='Close'
                                    >
                                        <X />
                                    </div>
                                </div>

                                <div
                                    className='alert alert-success d-flex align-items-center alert-dismissible fade show'
                                    role='alert'
                                >
                                    <CheckCircle className='mr-3' />
                                    این یک اخطار به همراه آیکون و به رنگ موفقیت
                                    آمیز است.
                                    <div
                                        className='alert-close'
                                        data-bs-dismiss='alert'
                                        aria-label='Close'
                                    >
                                        <X />
                                    </div>
                                </div>

                                <div
                                    className='alert alert-danger d-flex align-items-center alert-dismissible fade show'
                                    role='alert'
                                >
                                    <AlertOctagon className='mr-3' />
                                    این یک اخطار به همراه آیکون و به رنگ اخطار
                                    است.
                                    <div
                                        className='alert-close'
                                        data-bs-dismiss='alert'
                                        aria-label='Close'
                                    >
                                        <X />
                                    </div>
                                </div>

                                <div
                                    className='alert alert-warning d-flex align-items-center alert-dismissible fade show'
                                    role='alert'
                                >
                                    <AlertTriangle className='mr-3' />
                                    این یک اخطار به همراه آیکون و به رنگ هشدار
                                    است.
                                    <div
                                        className='alert-close'
                                        data-bs-dismiss='alert'
                                        aria-label='Close'
                                    >
                                        <X />
                                    </div>
                                </div>

                                <div
                                    className='alert alert-info d-flex align-items-center alert-dismissible fade show'
                                    role='alert'
                                >
                                    <Info className='mr-3' />
                                    این یک اخطار به همراه آیکون و به رنگ اطلاعات
                                    است.
                                    <div
                                        className='alert-close'
                                        data-bs-dismiss='alert'
                                        aria-label='Close'
                                    >
                                        <X />
                                    </div>
                                </div>

                                <div
                                    className='alert alert-light d-flex align-items-center alert-dismissible fade show'
                                    role='alert'
                                >
                                    <Sun className='mr-3' />
                                    این یک اخطار به همراه آیکون و به رنگ روشن
                                    است.
                                    <div
                                        className='alert-close'
                                        data-bs-dismiss='alert'
                                        aria-label='Close'
                                    >
                                        <X />
                                    </div>
                                </div>

                                <div
                                    className='alert alert-dark d-flex align-items-center alert-dismissible fade show'
                                    role='alert'
                                >
                                    <Moon className='mr-3' />
                                    این یک اخطار به همراه آیکون و به رنگ تیره
                                    است.
                                    <div
                                        className='alert-close'
                                        data-bs-dismiss='alert'
                                        aria-label='Close'
                                    >
                                        <X />
                                    </div>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>

                    <div className='col-12'>
                        <div className='card'>
                            <div className='card-title bg-transparent p-3'>
                                اطلاعیه و انواع موقعیت ها
                            </div>

                            <div className='card-body'>
                                <Button
                                    variant='success'
                                    className='mb-2 mr-2'
                                    onClick={topRight}
                                >
                                    بالا راست
                                </Button>

                                <Button
                                    variant='danger'
                                    className='mb-2 mr-2 '
                                    onClick={top}
                                >
                                    بالا وسط
                                </Button>

                                <Button
                                    variant='primary'
                                    className='mb-2 mr-2'
                                    onClick={topLeft}
                                >
                                    بالا چپ
                                </Button>

                                <Button
                                    variant='warning'
                                    className='mb-2 mr-2'
                                    onClick={bottomRight}
                                >
                                    پایین راست
                                </Button>

                                <Button
                                    variant='secondary'
                                    className='mb-2 mr-2'
                                    onClick={bottom}
                                >
                                    پایین وسط
                                </Button>

                                <Button
                                    variant='dark'
                                    className='mb-2 mr-2'
                                    onClick={bottomLeft}
                                >
                                    پایین چپ
                                </Button>
                            </div>

                            <ToastContainer />
                        </div>
                    </div>
                </Row>
            </Container>
        </>
    );
}
